<div class="w-full overflow-y-auto h-full">
    <div class="w-full p-2">
        <!-- Loading State - Skeleton -->
        <div *ngIf="isLoading" class="w-full py-6">
            <!-- Skeleton Plano Atual -->
            <div class="w-full py-6">
                <!-- Título -->
                <div class="h-6 bg-gray-300 rounded-xl w-32 ml-4 mb-4 animate-pulse"></div>

                <!-- Linhas -->
                <div class="w-full p-4 space-y-3">
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                </div>
            </div>

            <!-- Skeleton Recursos -->
            <div class="w-full py-6">
                <!-- Título -->
                <div class="h-6 bg-gray-300 rounded-xl w-40 ml-4 mb-4 animate-pulse"></div>

                <!-- Linhas -->
                <div class="w-full p-4 space-y-3">
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                </div>
            </div>

            <!-- Skeleton Cancelamento -->
            <div class="w-full py-6 border-t border-gray-200">
                <!-- Título -->
                <div class="h-6 bg-gray-300 rounded-xl w-36 ml-4 mb-4 animate-pulse"></div>

                <!-- Linhas -->
                <div class="w-full p-4 space-y-3">
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                    <div class="h-4 bg-gray-300 rounded-xl w-full animate-pulse"></div>
                </div>
            </div>
        </div>

        <!-- Plano Atual -->
        <div *ngIf="!isLoading && billingData" class="w-full py-6">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-purple-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:stars" class="icon-size-6 text-purple-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Plano Atual</span>
                    </div>
                </div>
            </div>
            <div class="w-full p-4">
                <!-- Nome do Plano -->
                <div class="py-4 border-b border-gray-100">
                    <div class="flex justify-between items-center">
                        <div>
                            <span class="text-[15px] font-inter font-[500] text-gray-600">Plano</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <mat-icon
                                class="icon-size-5"
                                [ngClass]="getPlanMedalColor(billingData.plan.name)"
                                [svgIcon]="billingData.plan.name?.toLowerCase() === 'no_subscription' ? 'mat_outline:error_outline' : 'mat_solid:military_tech'">
                            </mat-icon>
                            <span class="text-[14px] font-inter font-[500] text-gray-900">{{ billingData.plan.displayName }}</span>
                        </div>
                    </div>
                </div>

                <!-- Valor Mensal -->
                <div class="py-4 border-b border-gray-100">
                    <div class="flex justify-between items-center">
                        <div>
                            <span class="text-[15px] font-inter font-[500] text-gray-600">Valor Mensal</span>
                        </div>
                        <div>
                            <span class="text-[14px] font-inter font-[400] text-gray-900">
                                {{ billingData.plan.name?.toLowerCase() === 'no_subscription' ? '-' : 'R$ ' + (billingData.plan.price | number:'1.2-2':'pt-BR') }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Próxima Cobrança -->
                <div class="py-4 border-b border-gray-100">
                    <div class="flex justify-between items-center">
                        <div>
                            <span class="text-[15px] font-inter font-[500] text-gray-600">Próxima Cobrança</span>
                        </div>
                        <div>
                            <span class="text-[14px] font-inter font-[400] text-gray-900">
                                {{ (billingData.plan.name?.toLowerCase() === 'no_subscription' || !billingData.subscription?.nextBillingDate) ? '-' : (billingData.subscription?.nextBillingDate | date:'dd/MM/yyyy') }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Status -->
                <div class="py-4">
                    <div class="flex justify-between items-center">
                        <div>
                            <span class="text-[15px] font-inter font-[500] text-gray-600">Status</span>
                        </div>
                        <div>
                            <span *ngIf="billingData.plan.name?.toLowerCase() === 'no_subscription'" class="text-[14px] font-inter font-[400] text-gray-900">-</span>
                            <span *ngIf="billingData.plan.name?.toLowerCase() !== 'no_subscription'" class="px-3 py-1 rounded-full text-[12px] font-inter font-[500]"
                                  [ngClass]="{
                                      'bg-green-100 text-green-700': billingData.subscription?.status === 'active',
                                      'bg-yellow-100 text-yellow-700': billingData.subscription?.status === 'trialing',
                                      'bg-red-100 text-red-700': billingData.subscription?.status === 'canceled' || billingData.subscription?.status === 'past_due'
                                  }">
                                {{ billingData.subscription?.status === 'active' ? 'Ativa' :
                                   billingData.subscription?.status === 'trialing' ? 'Em Teste' :
                                   billingData.subscription?.status === 'canceled' ? 'Cancelada' : 'Vencida' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Botão Atualizar Plano -->
            <div class="w-full px-4 pb-4">
                <button
                    (click)="openUpdatePlanModal()"
                    class="fuse-mat-button-large rounded-[10px] bg-[#0061ff] border-0 w-full pointer-events-auto"
                    mat-stroked-button>
                    <mat-icon class="icon-size-5 fill-white"
                              [svgIcon]="'mat_outline:update'"></mat-icon>

                    <span class="ml-2 text-white font-inter">{{ billingData.plan.name?.toLowerCase() === 'no_subscription' ? 'Iniciar uma assinatura' : 'Atualizar plano' }}</span>
                </button>
            </div>
        </div>

        <!-- Recursos Incluídos -->
        <div *ngIf="!isLoading && billingData && billingData.plan?.name?.toLowerCase() !== 'no_subscription'" class="w-full py-6">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-blue-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:check_circle" class="icon-size-6 text-blue-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Recursos Incluídos</span>
                    </div>
                </div>
            </div>
            <div class="w-full p-4">
                <ul class="space-y-3">
                    <li *ngFor="let feature of getFormattedFeatures()" class="flex items-center gap-3">
                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'mat_solid:check_circle'"></mat-icon>
                        <span class="text-[14px] font-inter font-[400] text-gray-700">{{ feature }}</span>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Cancelamento -->
        <div *ngIf="billingData?.plan?.name?.toLowerCase() !== 'no_subscription'" class="w-full py-6 border-t border-gray-200">
            <div class="w-full p-4">
                <div class="flex flex-col gap-3">
                    <span class="text-[15px] font-inter font-[500] text-gray-900">Cancelar Assinatura</span>
                    <span class="text-[13px] font-inter font-[400] text-gray-500">
                        Ao cancelar sua assinatura, você perderá acesso a todos os recursos premium no final do período de cobrança atual.
                    </span>
                    <div class="mt-2">
                        <button
                            [disabled]="true"
                            class="px-6 py-2 rounded-lg bg-gray-300 text-gray-500 cursor-not-allowed font-inter text-[14px] font-[500] flex items-center gap-2">
                            <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:cancel'"></mat-icon>
                            Cancelar Assinatura
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
